import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { mailingAPI } from "../api/api";
import { MailingActionTypes } from "../actions/actionTypes";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() => mailingAPI.getSubsidiaries());

        yield put({
            type: MailingActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: MailingActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(MailingActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}
